var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SalesDashboardCard",
    {
      attrs: {
        title: "Recent Reviews",
        "class-card": "col-12",
        "with-filters": false
      }
    },
    [
      _c(
        "div",
        { attrs: { slot: "body" }, slot: "body" },
        [
          _vm.loading
            ? _c("Loader")
            : _c(
                "div",
                { staticClass: "d-flex flex-column" },
                _vm._l(_vm.ratings, function(rating) {
                  return _c(
                    "div",
                    {
                      key: rating.id,
                      staticClass: "rating-review",
                      on: {
                        click: function($event) {
                          _vm.openJob(rating)
                        }
                      }
                    },
                    [
                      _c("header", { staticClass: "rating-review-header" }, [
                        _c(
                          "div",
                          { staticClass: "rating-review-info-wrapper" },
                          [
                            _c(
                              "h5",
                              {
                                staticClass: "ref-id d-flex align-items-center"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(rating.ref_id) +
                                    "\n\n              "
                                ),
                                !rating.visible
                                  ? _c("span", {
                                      staticClass:
                                        "mod-icon-alert-octagon ml-2",
                                      attrs: { title: "Invisible review" }
                                    })
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("h6", { staticClass: "company-name" }, [
                              _vm._v(_vm._s(rating.company_name))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "rating-review-date" }, [
                          _vm._v(_vm._s(rating.date))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rating-review-author-info" }, [
                        _c("h5", { staticClass: "author-name" }, [
                          _vm._v(
                            _vm._s(rating.author.first_name) +
                              " " +
                              _vm._s(rating.author.last_name)
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "author-rating-wrapper" },
                          [
                            _c("span", { staticClass: "author-rating" }, [
                              _vm._v(_vm._s(rating.rating))
                            ]),
                            _vm._v(" "),
                            _c("star-rating", {
                              staticStyle: { "max-height": "16px" },
                              attrs: {
                                rating: rating.rating,
                                "star-size": 14,
                                "show-rating": false,
                                increment: 0.1,
                                "read-only": true
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "rating-review-body" }, [
                        _vm._v(
                          "\n          " + _vm._s(rating.body) + "\n        "
                        )
                      ])
                    ]
                  )
                })
              )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2918702", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2918702","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/salesDashboard/subcomponents/cards/RecentReviews.vue
// module id = null
// module chunks = 